<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.mybarco.ir\/storage\/assets\/Sprinkle (1).svg\");\nheight:100vh;"' class="container-fluid p-0 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"background:#fff;"' class="container-fluid nav307 shadow " >
                <template #default>   <m-nav-308 v-bind='{...{"menuPosition":"blog_footer","searchInput":"mSearchInput200"},...{}}' :style='""' class="bg-white" ></m-nav-308></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row pb-5 p-0 m-0" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.mybarco.ir\/storage\/assets\/banner4.png","alt":"\u0633\u0627\u0645\u0627\u0646\u0647 \u062d\u0645\u0644 \u0628\u0627\u0631"},...{}}' :style='" width: 500px;\nheight: 500px;\nobject-fit: contain;"' class="img-fluid mt-5 d-block mx-auto" ></m-img><m-copy-1 v-bind='{...{"itemId":21,"itemType":"product","iconName":"plus"},...{}}' :style='""' class="btn btn-primary" >
                <template #default>ثبت آگهی   </template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3" >
                <template #default>   </template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"height:80px;"' class="fixed-bottom w-100 bg-primary text-white" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row p-0 m-0 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-4 mx-auto pt-3" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/geramyan.com\/dashboard\/orders","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"clipboard check fill"},...{}}' :style='""' class="h3 text-white" ></m-icon><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>درخواست ها   </template>
                </m-p></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-4 mx-auto pt-3" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/mybarco.ir\/darandehbar\/store-dashboard\/products","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"truck"},...{}}' :style='""' class="h3 text-white" ></m-icon><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>بار های ثبت شده   </template>
                </m-p></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-4 mx-auto pt-3 copy" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":21,"itemType":"product","iconName":"plus"},...{}}' :style='""' class="" >
                <template #default>ثبت آگهی   </template>
                </m-copy-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav308 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav308/Nav308'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mNav308,mImg,mCopy1,mA,mIcon,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
